module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAQhJREFUOE9jZIACNWNjERYG9iiG/wyCMDGsNCPD+z8MP5fdOnv2DUieEUSANf9nO83AwLifkfH/A3wG/P/PqMDA8N/xD+MvU5AhYAO0jK3yGP4zGFw7dywJr+1QSS0jq3kMjAwXrp09NgligJFVPSPj//9Xzx5v0tPTU2RlZX1y9uzZ37gM0za2rPv/n5Hx2rljjRgGGBsbf/j//3/aD0Z2U0YGxhI0Q/78+81gyMT6PwinARS7gJgwwOsFIyOjWf/+/Zv2i5FTmIGR0QbDwB+/ZzJysqTh9ALMgN9MnOL/GRgtkA34z8Dw5y/jz5msDGxZOA2g2AsUB+IARSOlSZnizATPkWRkZwB+svURXRlCxAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/nav-user/application_icon_7.png
// module id = gLUw
// module chunks = 22